import { inject, Injectable } from '@angular/core';
import { from, Observable, of, switchMap, throwError } from 'rxjs';
import { CallbackContext } from '../callback-context';
import { OidcStorageService } from '../../storage/oidc-storage.service';
import { LoggerWrapper } from '../../../shared/providers/logger/logger-wrapper.service';
import { LoggerFactory } from '../../../shared/providers/logger/logger-factory.service';
import { OpenIdConfiguration } from '../../oidc-security.service';

@Injectable({ providedIn: 'root' })
export class RefreshSessionCallbackHandlerService {
  private logger: LoggerWrapper = inject(LoggerFactory).getInstance(this);

  constructor(private readonly oidcStorageService: OidcStorageService) {}

  // STEP 1 Refresh tokens
  retrieveRefreshToken(config: OpenIdConfiguration): Observable<CallbackContext> {
    return from(Promise.all([this.oidcStorageService.getRefreshToken(config.type)])).pipe(
      switchMap(([refreshToken]) => {
        if (refreshToken) {
          const callbackContext: CallbackContext = {
            code: null,
            refreshToken,
            state: null,
            authResult: null,
            validationResult: null,
          };

          return of(callbackContext);
        }
        return throwError(() => {
          this.logger.warn('no refresh token found, please login');
          return new Error('no refresh token found, please login');
        });
      })
    );
  }
}
